// Generated by `bazel run i18n`. Do not edit by hand.
import actionAuthorize_4abc4675 from "./en/src--action-authorize.json";
import csat_d29dc12e from "./en/src--csat.json";
import customization_1da3bcec from "./en/src--customization.json";
import list_8fd75d5d from "./en/src--list.json";
import login_16c6e00f from "./en/src--login.json";
import oms_4b084a13 from "./en/src--portal-four--oms.json";
import chooseRecipient_52ba26eb from "./en/src--portal-four--orders--gift-receipts--create-gift-receipt--choose-recipient.json";
import dispatcher_a4fff3ec from "./en/src--portal-four--orders--gift-receipts--create-gift-receipt--dispatcher.json";
import selectItems_fce7b787 from "./en/src--portal-four--orders--gift-receipts--create-gift-receipt--select-items.json";
import share_3faee74e from "./en/src--portal-four--orders--gift-receipts--details--share.json";
import details_f7180345 from "./en/src--portal-four--orders--gift-receipts--details.json";
import manage_8a4df42a from "./en/src--portal-four--orders--gift-receipts--manage.json";
import giftReceipts_4876e5eb from "./en/src--portal-four--orders--gift-receipts.json";
import hooks_3619711f from "./en/src--portal-four--orders--hooks.json";
import screens_5c2a1369 from "./en/src--portal-four--orders--hsa-reimburse--screens.json";
import hsaReimburse_063628c4 from "./en/src--portal-four--orders--hsa-reimburse.json";
import orderDetails_dd74d7bf from "./en/src--portal-four--orders--order-details.json";
import returnMethod_c66f9b3d from "./en/src--portal-four--orders--return-method.json";
import orders_2b352788 from "./en/src--portal-four--orders.json";
import components_db2b5472 from "./en/src--portal-four--register--components.json";
import hooks_cf05f73d from "./en/src--portal-four--register--hooks.json";
import screens_3972d294 from "./en/src--portal-four--register--screens.json";
import register_772ea854 from "./en/src--portal-four--register.json";
import additionalClaimDocuments_7125ad03 from "./en/src--portal-four--returns--additional-claim-documents.json";
import dropoffs_b6ebf55d from "./en/src--portal-four--returns--components--dropoffs.json";
import components_bb0632b4 from "./en/src--portal-four--returns--components.json";
import confirmationDisplay_f17a2b1a from "./en/src--portal-four--returns--confirmation-display.json";
import exchangeConversion_aecbbf43 from "./en/src--portal-four--returns--exchange-conversion.json";
import returns_048356d9 from "./en/src--portal-four--returns.json";
import sharedComponents_522eec4e from "./en/src--portal-four--shared-components.json";
import cart_dbeba823 from "./en/src--portal-four--submission--components--cart.json";
import media_a12a7872 from "./en/src--portal-four--submission--components--product-configurator--media.json";
import productOptions_984699c8 from "./en/src--portal-four--submission--components--product-configurator--product-options.json";
import productConfigurator_1f787557 from "./en/src--portal-four--submission--components--product-configurator.json";
import variantPicker_c7ff4e6f from "./en/src--portal-four--submission--components--variant-picker.json";
import components_08c46215 from "./en/src--portal-four--submission--components.json";
import hooks_72f8fafa from "./en/src--portal-four--submission--hooks.json";
import cart_7e0cc0fa from "./en/src--portal-four--submission--screens--cart.json";
import addExchangeItem_a917f6f8 from "./en/src--portal-four--submission--screens--choose-compensation-method--add-exchange-item.json";
import chooseCompensationMethod_6b1d026a from "./en/src--portal-four--submission--screens--choose-compensation-method.json";
import claimDocumentsReturn_53326c07 from "./en/src--portal-four--submission--screens--claim-documents-return.json";
import flowReturn_c6826d61 from "./en/src--portal-four--submission--screens--flow-return.json";
import itemDetails_0e103622 from "./en/src--portal-four--submission--screens--item-details.json";
import login_e403f734 from "./en/src--portal-four--submission--screens--login.json";
import merchantFlow_abf7885e from "./en/src--portal-four--submission--screens--merchant-flow.json";
import packagePickup_8b8eb2c7 from "./en/src--portal-four--submission--screens--package-pickup.json";
import merchantOverrides_3df0a245 from "./en/src--portal-four--submission--screens--review--merchant-overrides.json";
import review_2bf15c15 from "./en/src--portal-four--submission--screens--review.json";
import selectItems_6291372f from "./en/src--portal-four--submission--screens--select-items.json";
import shipmentMethod_96ee1469 from "./en/src--portal-four--submission--screens--shipment-method.json";
import shopNow_102d45ee from "./en/src--portal-four--submission--screens--shop-now.json";
import withdrawalReview_3ea844b4 from "./en/src--portal-four--submission--screens--withdrawal-review.json";
import submission_e1b84475 from "./en/src--portal-four--submission.json";

export default Object.assign(
  {},
  actionAuthorize_4abc4675,
  csat_d29dc12e,
  customization_1da3bcec,
  list_8fd75d5d,
  login_16c6e00f,
  oms_4b084a13,
  chooseRecipient_52ba26eb,
  dispatcher_a4fff3ec,
  selectItems_fce7b787,
  share_3faee74e,
  details_f7180345,
  manage_8a4df42a,
  giftReceipts_4876e5eb,
  hooks_3619711f,
  screens_5c2a1369,
  hsaReimburse_063628c4,
  orderDetails_dd74d7bf,
  returnMethod_c66f9b3d,
  orders_2b352788,
  components_db2b5472,
  hooks_cf05f73d,
  screens_3972d294,
  register_772ea854,
  additionalClaimDocuments_7125ad03,
  dropoffs_b6ebf55d,
  components_bb0632b4,
  confirmationDisplay_f17a2b1a,
  exchangeConversion_aecbbf43,
  returns_048356d9,
  sharedComponents_522eec4e,
  cart_dbeba823,
  media_a12a7872,
  productOptions_984699c8,
  productConfigurator_1f787557,
  variantPicker_c7ff4e6f,
  components_08c46215,
  hooks_72f8fafa,
  cart_7e0cc0fa,
  addExchangeItem_a917f6f8,
  chooseCompensationMethod_6b1d026a,
  claimDocumentsReturn_53326c07,
  flowReturn_c6826d61,
  itemDetails_0e103622,
  login_e403f734,
  merchantFlow_abf7885e,
  packagePickup_8b8eb2c7,
  merchantOverrides_3df0a245,
  review_2bf15c15,
  selectItems_6291372f,
  shipmentMethod_96ee1469,
  shopNow_102d45ee,
  withdrawalReview_3ea844b4,
  submission_e1b84475,
);
